<template>
  <div class="mt-6">
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-form ref="form" @submit.prevent="updateProduct">
        <v-card elevation="6" class="mb-10">
          <div class="pa-3">
            <div>
              <div class="mt-3 mr-1">
                <div class="d-flex">
                  <div class="ml-1" style="font-size: 22px">อัพเดทข้อมูลสินค้า</div>
                </div>
                <div class="mt-6 grid_img">
                  <div class="ml-4">
                    <v-img height="200" width="200" max-width="200" v-if="imagePreviewURL === null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                    <v-img height="200" width="200" max-width="200" v-if="imagePreviewURL !== null" :lazy-src="img_holder" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                  </div>
                </div>
                <div class="grid_img">
                  <div class="mt-3 mb-5 ml-1">
                    <v-file-input small-chips color="#86bc3a" label="รูปภาพสินค้าหลัก" prepend-icon="mdi-camera" hide-details="auto" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-4">
                <div class="ml-1" style="font-size: 22px"></div>
              </div>
              <div class="pa-3">
                <div class="d-flex">
                  <div class="ml-1" style="font-size: 22px">รูปภาพเพิ่มเติม</div>
                  <div class="ml-3 mt-n1">
                    <v-btn @click="multi_img" class="white--text grad-success-bg rounded pl-1 pr-1" title="เพิ่ม">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div class="grid_multi_img">
                  <div class="mr-2" v-for="(count, index) in img_list" :key="index">
                    <div class="mt-6">
                      <div class="ml-4">
                        <v-img height="200" max-width="200" v-if="count.product_preview === null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                        <v-img height="200" max-width="200" v-if="count.product_preview !== null" :lazy-src="img_holder" :src="count.product_preview" class="preview mx-auto"></v-img>
                      </div>
                    </div>
                    <div class="mt-3 mb-5 ml-1">
                      <div class="grid_input">
                        <div class="">
                          <v-file-input small-chips color="#86bc3a" label="รูปภาพสินค้าเพิ่มเติม" prepend-icon="mdi-camera" hide-details="auto" v-model="count.product_img_multi" @change="onFileChangeMulti(count.loop_id, count.product_img_multi)"></v-file-input>
                        </div>
                        <div class="ml-1" v-if="img_list.length > 0">
                          <div class="pt-4 pl-3 img_hover" @click="delete_img(count.loop_id)"><v-icon title="ลบ">mdi-trash-can-outline</v-icon></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อสินค้า" prepend-inner-icon="mdi-cart-outline" :rules="[v => !!v || 'กรุณากรอกชื่อสินค้า']" required hide-details="auto" v-model="getProduct_list.name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อทางการแพทย์" prepend-inner-icon="mdi-beaker-outline" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อทางการแพทย์']" required v-model="getProduct_list.name_sci" outlined></v-text-field>
                </div>

                <div class="mt-3 mr-1">
                  <v-autocomplete color="#86bc3a" :items="getType_product" item-text="name" item-value="id" v-model="getProduct_list.product_type" label="ประเภทสินค้า" :rules="[v => !!v || 'กรุณากรอกประเภทสินค้า']" required prepend-inner-icon="mdi-format-list-bulleted-type" hide-details="auto" outlined></v-autocomplete>
                </div>

                <div class="mt-3 mr-1">
                  <v-autocomplete multiple small-chips clearable color="#86bc3a" :items="getType_supplier" item-text="sup_name" item-value="sup_id" v-model="getSupplier_list" label="ซัพพลายเออร์" :rules="[v => !!v || 'กรุณากรอกซัพพลายเออร์']" required prepend-inner-icon="mdi-semantic-web" hide-details="auto" outlined></v-autocomplete>
                </div>

                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="number" label="จำนวนสินค้าในคลังไม่ควรน้อยกว่า" @keypress="isOnlyNumber($event)" min="0" :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้าไม่ควรน้อยกว่า']" required prepend-inner-icon="mdi-book-arrow-up-outline" hide-details="auto" v-model="getProduct_list.min_qty" outlined></v-text-field>
                </div>
                <div class="mt-3 ml-1">
                  <div class="d-flex align-center">
                    <v-checkbox color="#86bc3a" class="ma-4 ml-6" v-model="getProduct_list.retail_status" hide-details="auto"></v-checkbox>
                    <div>
                      ขายปลีก (แสดงสินค้าขายเฉพาะขายปลีกเท่านั้น)
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid_full mt-10">
                <div class="mt-3 mr-1">
                  <v-textarea color="#86bc3a" label="รายละเอียด" prepend-inner-icon="mdi-text" hide-details="auto" v-model="getProduct_list.detail" outlined></v-textarea>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 ml-1">
                  <div class="d-flex align-center">
                    <v-checkbox color="#86bc3a" class="ma-4 ml-6" v-model="getProduct_list.claim_status" hide-details="auto"></v-checkbox>
                    <div>
                      ลูกค้าส่งสามารถเครมสินค้าหมดอายุได้
                    </div>
                  </div>
                </div>
                <div class="mt-3 mb-3" v-if="getProduct_list.claim_status == true || getProduct_list.claim_status == 1">
                  <v-autocomplete color="#86bc3a" :items="items" item-text="name" item-value="id" prepend-inner-icon="mdi-progress-question" :rules="[v => !!v || 'กรุณาเลือกเงื่อนไขการเคลมสินค้า']" label="เงื่อนไขการเคลมสินค้า" v-model="getProduct_list.condition_id" hide-details="auto" outlined/>
                </div>
              </div>
              <div class="grid_full">
                <!--              <div class="ml-2 mb-2">หมายเหตุ</div>-->
                <v-text-field color="#86bc3a" type="text" label="หมายเหตุ (หมายเหตุนี้จะไม่แสดงในส่วนของลูกค้า)" prepend-inner-icon="mdi-message-bulleted" hide-details="auto" v-model="getProduct_list.note" outlined></v-text-field>
              </div>
            </div>
          </div>
        </v-card>
        <div class="mt-2">
          <v-card elevation="6">
            <div class="pa-3">
              <div class="mt-3 mr-1">
                <div class="d-flex">
                  <div class="ml-1">ข้อมูลหน่วยนับ</div>
                </div>
              </div>
              <div class="mb-n7">
                <small style="color:red;">* หน่วยหลัก</small>
              </div>
              <div class="grid_col mt-5">
                <div class="mt-3 mr-1">
                  <v-autocomplete color="#86bc3a" :rules="[v => !!v || 'กรุณาเลือกหน่วยนับ']" :items="main_unit_list" item-text="name" item-value="id" label="หน่วยนับ" v-model="getProduct_list.main_unit_type" hide-details="auto" required outlined/>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="บาร์โค้ด" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกบาร์โค้ด']" v-model="getProduct_list.main_barcode" required outlined></v-text-field>
                </div>

                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="number" label="น้ำหนัก(กิโลกรัม)" :rules="[v => !!v || 'กรุณากรอกน้ำหนัก(กิโลกรัม)']" min="0" @keypress="isCurrency($event, getProduct_list.main_weight)" hide-details="auto" v-model="getProduct_list.main_weight" required outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1 d-flex">
                  <v-text-field color="#86bc3a" type="number" label="จำกัดการซื้อห้ามเกิน" min="0" hide-details="auto" v-model="getProduct_list.main_limit_purchase" required outlined></v-text-field>
                </div>
              </div>
              <div v-for="(unit,index) in getUnit_list " :key="index">
                <div class="grid_col mt-5">
                  <div class="mt-3 mr-1">
                    <v-autocomplete color="#86bc3a" :rules="[v => !!v || 'กรุณาเลือกหน่วยนับ']" :items="type_unit" item-text="name" item-value="id" label="หน่วยนับ" v-model="unit.unit_id" hide-details="auto" required outlined/>
                  </div>
                  <div class="mt-3 mr-1">
                    <v-text-field color="#86bc3a" label="บาร์โค้ด" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกบาร์โค้ด']" v-model="unit.barcode" required outlined></v-text-field>
                  </div>

                  <div class="mt-3 mr-1">
                    <v-text-field color="#86bc3a" type="number" label="น้ำหนัก(กิโลกรัม)" :rules="[v => !!v || 'กรุณากรอกน้ำหนัก(กิโลกรัม)']" min="0" @keypress="isCurrency($event, unit.weight)" hide-details="auto" v-model="unit.weight" required outlined></v-text-field>
                  </div>
                  <div class="mt-3 mr-1 d-flex">
                    <v-text-field color="#86bc3a" type="number" label="จำกัดการซื้อห้ามเกิน" min="0" hide-details="auto" v-model="unit.limit_purchase" required outlined></v-text-field>
                    <div class="ml-1" v-if="getUnit_list.length > 0">
                      <v-btn @click="deleteUnit(unit.id, unit.id_loop)" height="55" class="grad-danger-bg white--text"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right mt-3">
                <v-btn large @click="addUnit()" class="white--text grad-success-bg" style="font-size: 18px">เพิ่มหน่วยนับ</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn large class="white--text grad-success-bg" style="font-size: 18px" type="submit">บันทึกข้อมูล</v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </v-form>
    </div>
  </div>
</template>
<script src="@/previewimage.js"></script><script>
import img_holder from "@/assets/pharmacy.png"
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {onlyForCurrency, onlyForNumber} from "@/js/handler";

export default {
  name: "Product_edit",
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      checkbox: null,
      img_holder: img_holder,
      pro_pic_name: null,
      imagePreviewURL: null,
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      default_img: null,
      name: null,
      status_id: null,
      status_retail: null,
      // { id: 1, name: '30 วัน' },
      // { id: 2, name: '90 วัน' },
      items: [
        { id: 0, name: 'ไม่มี' },
        { id: 3, name: '120 วัน' },
        { id: 4, name: '240 วัน' },
        { id: 5, name: '365 วัน' },
      ],
      typeItems: [
        { id: 1, name: 'กล่อง' },
        { id: 2, name: 'แพ็ค' },
        { id: 3, name: 'แผง' },
        { id: 4, name: 'เม็ด' },
      ],
      id_loop: null,
      getProduct_list: {
        id: null,
        claim_status: null,
        condition_id: null,
        detail: '',
        min_qty: null,
        name: null,
        name_sci: null,
        retail_status: null,
        product_code: null,
        product_type: null,
        supplier_id: null,
        note: '',
        main_id: null,
        main_unit_type: null,
        main_barcode: null,
        main_weight: null,
        main_limit_purchase: null,
      },
      supplier_id: null,
      getSupplier_list: [],
      getUnit_list: [],
      main_unit_list: [],
      getType_product: [],
      getType_supplier: [],
      type_unit: [],
      img_list: [],
      multi_id: 0,
    }
  },
  methods: {
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.pro_pic_name = null
          })
        }else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.pro_pic_name = null
          }
        }
      }
      else {
        this.imagePreviewURL = null
        this.pro_pic_name = null
      }
    },
    onFileChangeMulti(mul_id, payload) {
      let file = payload
      this.img_list.forEach((data) => {
        if (data.loop_id === mul_id) {
          if (payload !== null && payload !== undefined) {
            let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
            let file_ext = file.name;
            let ext = file_ext.split('.').pop().toLowerCase();
            if (parseInt(extall.indexOf(ext)) < 0) {
              Swal.fire({
                text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                data.product_preview = null
                // data.product_img_multi = null
              })
            }
            else {
              if (file) {
                data.product_img_multi = file
                data.product_preview = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
              }
              else {

              }
            }
          }
          else {
            data.product_preview = null
            // data.product_img_multi = null
          }
        }
      })
    },
    addUnit() {
      const id = this.id_loop+= 1;
      this.getUnit_list.push({
        "id_loop": id,
        "id": null,
        "unit_id": null,
        "barcode": null,
        "weight": null,
        "limit_purchase": null,
      })
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 3000);
    },
    deleteUnit(id, id_loop) {
      if (this.id_loop <= null) {
        // console.log('DB' + id);
        this.getUnit_list = this.getUnit_list.filter(detail => detail.id !== id)
        HTTP.post('/products/productlist/delete', {
          id: id
        }).then((res) => {
          if (res.data.success === true){
            this.alert_danger = true;
            setTimeout(() => this.alert_danger = false, 3000);
          }
        })
      }
      else if(this.id_loop >= 1){
        this.getUnit_list = this.getUnit_list.filter(detail => detail.id_loop !== id_loop);
        this.alert_danger = true;
        setTimeout(() => this.alert_danger = false, 3000);
      }
    },
    updateProduct() {
      let id = this.$route.params.id
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      if (this.getProduct_list.claim_status == true) {
        this.status_id = 1;
      }
      else if (this.getProduct_list.claim_status == false) {
        this.status_id = 0;
      }

      if (this.getProduct_list.retail_status == true) {
        this.status_retail = 1;
      }
      else if (this.getProduct_list.retail_status == false) {
        this.status_retail = 0;
      }

      if (this.status_id == 0){
        this.getProduct_list.condition_id = null;
      }
      if (this.getSupplier_list.length > 0) {
        if (this.status_id == 1) {
          if (this.$refs.form.validate()) {
            let formData = new FormData();
            if (this.pro_pic_name === null){
              formData.append('product_id', id)
              formData.append('product_name', this.getProduct_list.name);
              formData.append('medical_name', this.getProduct_list.name_sci);
              formData.append('product_type', this.getProduct_list.product_type);
              formData.append('product_detail', this.getProduct_list.detail);
              formData.append('note', this.getProduct_list.note);
              formData.append('suppliers', JSON.stringify(this.getSupplier_list));
              formData.append('min_qty', this.getProduct_list.min_qty);
              formData.append('claim_status', this.status_id);
              formData.append('retail_status', this.status_retail);
              formData.append('condition_id', this.getProduct_list.condition_id);
              formData.append('main_id', this.getProduct_list.main_id);
              formData.append('main_unit_type', this.getProduct_list.main_unit_type)
              formData.append('main_barcode', this.getProduct_list.main_barcode)
              formData.append('main_weight', this.getProduct_list.main_weight)
              formData.append('main_limit_purchase', this.getProduct_list.main_limit_purchase)
              let arr_id = []
              let arr_img = []
              this.img_list.forEach((data, index) => {
                arr_id = data.id
                arr_img = data.product_img_multi
                formData.append('picture_id[' + index + ']', arr_id)
                formData.append('picture_more[' + index + ']', arr_img)
              })
              let arr_all = [];
              this.getUnit_list.forEach((details) => {
                arr_all.push({
                  // "id_loop": details.id_loop,
                  "id": details.id,
                  "unit_id": details.unit_id,
                  "barcode": details.barcode,
                  "weight": details.weight,
                  "limit_purchase": details.limit_purchase,
                })
              });
              formData.append('unit_add', JSON.stringify(arr_all));
              HTTP.post('/products/product/edit', formData, config)
                  .then((res) => {
                    if (res.data.success === true){
                      Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success')
                          .then(() => {
                            // this.$router.push('/stock/manage_product/productlist');
                            this.$router.push('/'+ this.$store.state.link_url)
                          })
                    }
                    else {
                      Swal.fire({
                        title: 'ไม่สามารถดำเนินการได้ !',
                        text: res.data.message,
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                      })
                    }
                  })
            }else {
              let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
              let file = this.pro_pic_name.name;
              let ext = file.split('.').pop().toLowerCase();
              if (parseInt(extall.indexOf(ext)) < 0) {
                Swal.fire({
                  text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  this.imagePreviewURL = null
                  this.pro_pic_name = null
                })
              }else {
                formData.append('product_id', id)
                formData.append('product_image', this.pro_pic_name, this.pro_pic_name.name);
                formData.append('product_name', this.getProduct_list.name);
                formData.append('medical_name', this.getProduct_list.name_sci);
                formData.append('product_type', this.getProduct_list.product_type);
                formData.append('product_detail', this.getProduct_list.detail);
                formData.append('note', this.getProduct_list.note);
                formData.append('suppliers', JSON.stringify(this.getSupplier_list));
                formData.append('min_qty', this.getProduct_list.min_qty);
                formData.append('claim_status', this.status_id);
                formData.append('retail_status', this.status_retail);
                formData.append('condition_id', this.getProduct_list.condition_id);
                formData.append('main_id', this.getProduct_list.main_id);
                formData.append('main_unit_type', this.getProduct_list.main_unit_type)
                formData.append('main_barcode', this.getProduct_list.main_barcode)
                formData.append('main_weight', this.getProduct_list.main_weight)
                formData.append('main_limit_purchase', this.getProduct_list.main_limit_purchase)
                let arr_id = []
                let arr_img = []
                this.img_list.forEach((data, index) => {
                  arr_id = data.id
                  arr_img = data.product_img_multi
                  formData.append('picture_id[' + index + ']', arr_id)
                  formData.append('picture_more[' + index + ']', arr_img)
                })
                let arr_all = [];
                this.getUnit_list.forEach((details) => {
                  arr_all.push({
                    // "id_loop": details.id_loop,
                    "id": details.id,
                    "unit_id": details.unit_id,
                    "barcode": details.barcode,
                    "weight": details.weight,
                    "limit_purchase": details.limit_purchase,
                  })
                });
                formData.append('unit_add', JSON.stringify(arr_all));
                HTTP.post('/products/product/edit', formData, config)
                    .then((res) => {
                      if (res.data.success === true){
                        Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success')
                            .then(() => {
                              // this.$router.push('/stock/manage_product/productlist');
                              this.$router.push('/'+ this.$store.state.link_url)
                            })
                      }
                      else {
                        Swal.fire({
                          title: 'ไม่สามารถดำเนินการได้ !',
                          text: res.data.message,
                          icon: 'error',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: `ตกลง`,
                          denyButtonText: `ยกเลิก`,
                        })
                      }
                    })
              }
            }
          }
        }
        else {
          if (this.$refs.form.validate()) {
            let formData = new FormData();
            if (this.pro_pic_name === null){
              formData.append('product_id', id)
              formData.append('product_name', this.getProduct_list.name);
              formData.append('medical_name', this.getProduct_list.name_sci);
              formData.append('product_type', this.getProduct_list.product_type);
              formData.append('product_detail', this.getProduct_list.detail);
              formData.append('note', this.getProduct_list.note);
              formData.append('suppliers', JSON.stringify(this.getSupplier_list));
              formData.append('min_qty', this.getProduct_list.min_qty);
              formData.append('claim_status', this.status_id);
              formData.append('retail_status', this.status_retail);
              formData.append('condition_id', this.getProduct_list.condition_id);
              formData.append('main_id', this.getProduct_list.main_id);
              formData.append('main_unit_type', this.getProduct_list.main_unit_type)
              formData.append('main_barcode', this.getProduct_list.main_barcode)
              formData.append('main_weight', this.getProduct_list.main_weight)
              formData.append('main_limit_purchase', this.getProduct_list.main_limit_purchase)
              let arr_id = []
              let arr_img = []
              this.img_list.forEach((data, index) => {
                arr_id = data.id
                arr_img = data.product_img_multi
                formData.append('picture_id[' + index + ']', arr_id)
                formData.append('picture_more[' + index + ']', arr_img)
              })
              let arr_all = [];
              this.getUnit_list.forEach((details) => {
                arr_all.push({
                  // "id_loop": details.id_loop,
                  "id": details.id,
                  "unit_id": details.unit_id,
                  "barcode": details.barcode,
                  "weight": details.weight,
                  "limit_purchase": details.limit_purchase,
                })
              });
              formData.append('unit_add', JSON.stringify(arr_all));
              HTTP.post('/products/product/edit', formData, config)
                  .then((res) => {
                    if (res.data.success === true){
                      Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success')
                          .then(() => {
                            // this.$router.push('/stock/manage_product/productlist');
                            this.$router.push('/'+ this.$store.state.link_url)
                          })
                    }
                    else {
                      Swal.fire({
                        title: 'ไม่สามารถดำเนินการได้ !',
                        text: res.data.message,
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                      })
                    }
                  })
            }else {
              let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
              let file = this.pro_pic_name.name;
              let ext = file.split('.').pop().toLowerCase();
              if (parseInt(extall.indexOf(ext)) < 0) {
                Swal.fire({
                  text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  this.imagePreviewURL = null
                  this.pro_pic_name = null
                })
              }else {
                formData.append('product_id', id)
                formData.append('product_image', this.pro_pic_name, this.pro_pic_name.name);
                formData.append('product_name', this.getProduct_list.name);
                formData.append('medical_name', this.getProduct_list.name_sci);
                formData.append('product_type', this.getProduct_list.product_type);
                formData.append('product_detail', this.getProduct_list.detail);
                formData.append('suppliers', JSON.stringify(this.getSupplier_list));
                formData.append('min_qty', this.getProduct_list.min_qty);
                formData.append('claim_status', this.status_id);
                formData.append('retail_status', this.status_retail);
                formData.append('condition_id', this.getProduct_list.condition_id);
                formData.append('main_id', this.getProduct_list.main_id);
                formData.append('main_unit_type', this.getProduct_list.main_unit_type)
                formData.append('main_barcode', this.getProduct_list.main_barcode)
                formData.append('main_weight', this.getProduct_list.main_weight)
                formData.append('main_limit_purchase', this.getProduct_list.main_limit_purchase)
                let arr_id = []
                let arr_img = []
                this.img_list.forEach((data, index) => {
                  arr_id = data.id
                  arr_img = data.product_img_multi
                  formData.append('picture_id[' + index + ']', arr_id)
                  formData.append('picture_more[' + index + ']', arr_img)
                })
                let arr_all = [];
                this.getUnit_list.forEach((details) => {
                  arr_all.push({
                    // "id_loop": details.id_loop,
                    "id": details.id,
                    "unit_id": details.unit_id,
                    "barcode": details.barcode,
                    "weight": details.weight,
                    "limit_purchase": details.limit_purchase,
                  })
                });
                formData.append('unit_add', JSON.stringify(arr_all));
                HTTP.post('/products/product/edit', formData, config)
                    .then((res) => {
                      if (res.data.success === true){
                        Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success')
                            .then(() => {
                              // this.$router.push('/stock/manage_product/productlist');
                              this.$router.push('/'+ this.$store.state.link_url)
                            })
                      }
                      else {
                        Swal.fire({
                          title: 'ไม่สามารถดำเนินการได้ !',
                          text: res.data.message,
                          icon: 'error',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: `ตกลง`,
                          denyButtonText: `ยกเลิก`,
                        })
                      }
                    })
              }
            }
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: 'กรุณากรอกข้อมูล !',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณาเลือก ซัพพลายเออร์ !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getSupplier_type() {
      HTTP.post('/suppliers/all')
          .then((res) => {
            if (res.data.success === true){
              this.getType_supplier = res.data.object.map((obj) => {
                return {
                  id: obj.id,
                  sup_id: obj.id,
                  sup_name: obj.department !== '-' && obj.department !== null ? obj.name +' ('+ obj.department +')': obj.name,
                }
              });
            }
          })
    },
    getProduct() {
      this.loading_page = true;
      const id = this.$route.params.id;
      HTTP.post('/products/product/show/' + id)
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false;
              this.getProduct_list.id = res.data.product.id;
              this.getProduct_list.claim_status = res.data.product.claim_status;
              this.getProduct_list.retail_status = res.data.product.retail_status;
              this.getProduct_list.condition_id = res.data.product.condition_id;
              this.getProduct_list.min_qty = res.data.product.min_qty;
              this.getProduct_list.name = res.data.product.name;
              if (res.data.product.note !== null && res.data.product.note !== 'null') {
                this.getProduct_list.note = res.data.product.note;
              }
              else {
                this.getProduct_list.note = '-'
              }
              if (res.data.product.detail !== null && res.data.product.detail !== 'null') {
                this.getProduct_list.detail = res.data.product.detail;
              }
              else {
                this.getProduct_list.detail = '-'
              }
              this.imagePreviewURL = res.data.product.picture;
              this.getProduct_list.name_sci = res.data.product.name_sci;
              this.getProduct_list.product_code = res.data.product.product_code;
              this.getProduct_list.product_type = res.data.product.product_type;
              this.getUnit_list = res.data.product_list;
              this.getProduct_list.main_id = res.data.unit_main.id
              this.getProduct_list.main_unit_type = res.data.unit_main.unit_id
              this.getProduct_list.main_barcode = res.data.unit_main.barcode
              this.getProduct_list.main_weight = res.data.unit_main.weight
              this.getProduct_list.main_limit_purchase = res.data.unit_main.limit_purchase
              this.getSupplier_list = res.data.product_supplier.map(data => data.sup_id);
              res.data.picmores.forEach((data) => {
                this.multi_id += 1;
                this.img_list.push({
                  loop_id: this.multi_id,
                  id: data.id,
                  product_img_multi: [],
                  product_preview: data.picture,
                })
              })
            } else{
              Swal.fire({
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                // this.$router.push('/stock/manage_product/productlist')
                this.$router.push('/'+ this.$store.state.link_url)
              })
            }
          })
    },
    multi_img() {
      this.multi_id += 1;
      this.img_list.push({
        loop_id: this.multi_id,
        id: null,
        product_img_multi: [],
        product_preview: null,
      })
    },
    delete_img(loop_id) {
      this.img_list = this.img_list.filter(detail => detail.loop_id !== loop_id)
    },
    getProduct_type() {
      HTTP.post('/products/producttype/all')
          .then((res) => {
            if (res.data.success === true){
              this.getType_product = res.data.object;
            }
          })
    },
    get_main_unit() {
      HTTP.get('/products/units/one')
          .then((res) => {
            if (res.data.success === true) {
              this.main_unit_list = res.data.object
            }
          })
    },
    get_unit() {
      HTTP.get('/products/units/moreone')
          .then((res) => {
            if (res.data.success === true){
              this.type_unit = res.data.object;
            }
          })
    },
    checkLogIn() {
      let id = this.$route.params.id;
      if (this.$route.path == '/stock/manage_product/productedit/' + id) {
        if (this.$store.state.userDetail.manage_product_edit != 1) {
          this.$router.push('/stock/manage_product/productlist')
        }
      }
    }
  },
  beforeMount() {
    this.checkLogIn();
  },
  mounted() {
    this.getProduct();
    this.getProduct_type();
    this.getSupplier_type();
    this.get_unit();
    this.get_main_unit();
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_col {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_img {
  display: grid;
  grid-template-columns: 25% 85%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.preview {
  border-radius: 8px;
}
.grid_multi_img {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}
.grid_input {
  display: grid;
  grid-template-columns: 90% 10%;
}
.img_hover {
  cursor: pointer;
}
@media only screen and (max-width: 1100px) {
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_col {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 650px) {
  .grid_col {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_multi_img {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
